import { create } from 'zustand';

const useLayersStore = create((set) => ({
  collapsedKeys: new Set(),
  selectedKeys: [],
  selectedRelatives: [],

  toggleCollapse: (key) =>
    set((state) => {
      const next = new Set(state.collapsedKeys);
      if (next.has(key)) {
        next.delete(key);
      } else {
        next.add(key);
      }
      return { collapsedKeys: next };
    }),

  setCollapsed: (key, isCollapsed) =>
    set((state) => {
      const next = new Set(state.collapsedKeys);
      if (isCollapsed) {
        next.add(key);
      } else {
        next.delete(key);
      }
      return { collapsedKeys: next };
    }),

  setSelectedKeys: (keys) => set({ selectedKeys: keys }),

  setSelectedRelatives: (ids) => set({ selectedRelatives: ids }),

  reset: () =>
    set({
      collapsedKeys: new Set(),
      selectedKeys: [],
      selectedRelatives: [],
    }),
}));

export default useLayersStore;
